import React, { useState, useEffect, useRef } from 'react';
import './ProjectsSection.css';
import ProjectCard from './ProjectCard';

import cs1 from '../assets/cs1.webp';
import cs2 from '../assets/cs2.webp';
import cs3 from '../assets/cs3.webp';

const projects = [
  {
    title: 'Confinze',
    paragraph: 'Empowering financial control: Confinze\'s journey towards a 85% retention rate',
    image: cs1,
    backgroundColor: '#f0faff',
  },
  {
    title: 'Desporto Escolar',
    paragraph: 'A faster platform for a national sports program',
    image: cs2,
    backgroundColor: '#e8f6f0',
  },
  {
    title: 'Eurofound',
    paragraph: 'Creating a user-friendly interface for more than 280 initiatives in just 6 weeks',
    image: cs3,
    backgroundColor: '#f3f4f4',
  },
];

const ProjectsSection = () => {
  const centerCardRef = useRef(null);
  const previousScrollY = useRef(window.scrollY);
  const yOffset = useRef(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const cardGroupRef = useRef(null);

  // Handle scroll animation (desktop only)
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 768 && centerCardRef.current) {
        const currentScrollY = window.scrollY;
        const deltaY = currentScrollY - previousScrollY.current;
        const direction = deltaY > 0 ? 'down' : 'up';
        
        const change = direction === 'down' ? -1.5 : 1.5;
        let newOffset = yOffset.current + change;
        newOffset = Math.max(-40, Math.min(40, newOffset));
        yOffset.current = newOffset;

        centerCardRef.current.style.transform = `translate3d(0, ${newOffset}px, 0)`;
        previousScrollY.current = currentScrollY;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle carousel scroll (mobile only)
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 768 && cardGroupRef.current) {
        const scrollLeft = cardGroupRef.current.scrollLeft;
        const cardWidth = cardGroupRef.current.children[0]?.offsetWidth || 0;
        const newSlide = Math.round(scrollLeft / (cardWidth + 16)); // 16px gap
        setCurrentSlide(newSlide);
      }
    };

    const cardGroup = cardGroupRef.current;
    if (cardGroup) {
      cardGroup.addEventListener('scroll', handleScroll);
      return () => cardGroup.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <section id="projects" className="projects-section2242">
      <div className="container">
        <div className="projects-header2242">
          <div className="projects-header-left2242">
            <h2>
              PROJECTS<br />
              <span className="blue-part1">SUCCESSFULLY<br />DELIVERED</span>
            </h2>
          </div>
          <div className="projects-header-right2242">
            <p>
              Since 2020, we've delivered more than 300 web and software products, in over 15 different industries.
            </p>
          </div>
        </div>

        <div className="project-card-group2242" ref={cardGroupRef}>
          {projects.map((item, i) => (
            <div
              key={i}
              ref={i === 1 ? centerCardRef : null}
              className="project-card-wrapper2242"
            >
              <ProjectCard
                title={item.title}
                paragraph={item.paragraph}
                image={item.image}
                backgroundColor={item.backgroundColor}
                isCentered={i === 1}
              />
            </div>
          ))}
        </div>

        {/* Carousel dots for mobile */}
       
          </div>
    </section>
  );
};

export default ProjectsSection;